var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnMinus = function SvgBtnMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2537",
    transform: "translate(-587 -651)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1849",
    width: 24,
    height: 24,
    rx: 5,
    transform: "translate(587 651)",
    fill: "#ecf1f4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2484",
    d: "M595 663.4V662h8v1.4Z",
    fill: "currentColor"
  }))));
};
export default SvgBtnMinus;